import CustomAttachment from './CustomAttachment';

export default CustomAttachment;
